<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p20-1.jpg"
              width="100%"
              alt="蓝鲨 Robor 安全驾驶辅助系统"
            />
          </div>
          <div class="text t20">
            <div class="t20_1 fs_content">前摄像头（选装）</div>
            <div class="fs_tiny">实时监控行车状况</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p20-2.jpg"
              width="100%"
              alt="蓝鲨 Robor 安全驾驶辅助系统"
            />
          </div>
          <div class="text t20">
            <div class="t20_1 fs_content">后摄像头</div>
            <div class="fs_tiny">实时监控行车状况</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p20-3.jpg"
              width="100%"
              alt="蓝鲨 Robor 安全驾驶辅助系统"
            />
          </div>
          <div class="text t20">
            <div class="t20_1 fs_content">超声探头</div>
            <div class="fs_tiny">实时提醒保持车距</div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t20 {
  bottom: 8vw;
  text-align: center;
  width: 100%;
  .t20_1 {
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper20.vue